import Encrypt from '../helpers/encrypt'

const TOKEN = '$2a$14$KLlJaqMa5cjyNiyhVta3Seu0K1XxD76HXoJgwCPiZa1j5wBxgpNp2'

class Token {
  set (item) {
    const encryptToken = Encrypt.encodeToken(item)
    return localStorage.setItem(TOKEN, encryptToken)
  }
  get () {
    return localStorage.getItem(TOKEN) !== null ? Encrypt.decodeToken(localStorage.getItem(TOKEN)) : null
  }
  remove () {
    return localStorage.removeItem(TOKEN)
  }
}

export default new Token()